import { ProgramType, Roles } from '../enums';
import { UserInfo } from '../models/auth/user-info.model';

export const getUserRole = (userInfo: UserInfo) => {
  if (userInfo.IsSysAdmin) {
    return Roles.SystemAdmin;
  } else if (userInfo.IsSiteAdmin) {
    return Roles.SiteAdmin;
  } else if (userInfo.IsCoordinator) {
    return 'Coordinator';
  } else if (userInfo.IsSupervisor) {
    return 'Supervisor';
  } else if (userInfo.IsObserver) {
    return 'Observer';
  } else if (userInfo.IsTrainer) {
    return userInfo.CurrentProgram.Type === ProgramType.FieldTraining ? 'Trainer' : 'Mentor';
  } else if (userInfo.IsTrainee) {
    return userInfo.CurrentProgram.Type === ProgramType.FieldTraining
      ? 'Trainee'
      : userInfo.CurrentProgram.Type === ProgramType.Mentoring
      ? 'Mentee'
      : 'Employee';
  } else {
    return 'Unknown';
  }
};
